var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.noticeFirst.title,"visible":true},on:{"close":_vm.noticeClose}},[_c('div',{staticClass:"dialog-notice-div",domProps:{"innerHTML":_vm._s(_vm.noticeFirst.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }